/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {CreativeCopyInBulkModalComponent} from './creative-copy-in-bulk-modal.component';

@Injectable({providedIn: 'root'})
export class CreativeCopyInBulkModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(list: any, Creative: any, onComplete?: (updatedCreatives?: any, bulkSelection?: any) => void): void {
    this.angularModalService.show(CreativeCopyInBulkModalComponent, {
      initialState: {
        list,
        Creative,
        onComplete
      }
    });
  }
}
